// extracted by mini-css-extract-plugin
export default {"StaticToolbar":"StaticToolbarPlugin_StaticToolbar__M+bNd","Divider":"StaticToolbarPlugin_Divider__zXQ4s"};